import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class RevenueBudgetForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      accounts: [],
    },
    data: {
      revenue_sub_account_id: "",
      half_year_id: "",
      budget: "",
      attachment: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const { aid, edit } = this.context.popUp;

    if (edit) {
      data.revenue_sub_account_id = edit.revenue_sub_account_id;
      data.half_year_id = edit.half_year_id;
      data.budget = edit.budget;
    }

    await db
      .getAll(`dropdowns/revenueSubAccounts`)
      .then(({ data: { data } }) => {
        drp["accounts"] = data.filter(
          (item) => item.revenue_account_id === parseInt(aid)
        );
      });

    await db
      .getAll(`dropdowns/halfYears`)
      .then(({ data: { data } }) => (drp["halfYears"] = data));

    this.setState({ drp, data });
  };

  schema = {
    revenue_sub_account_id: Joi.number().required(),
    half_year_id: Joi.number().required(),
    budget: Joi.number().required(),
    attachment: Joi.allow(null).allow(""),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        ...this.state.data,
      });

      await db
        .form("revenues/budget", target, __controls, popUp?.edit?.id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })
        .catch((e) => {
          togglePopUp({
            form: "toast",
            message: e.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditBudget : lbl.SaveBudget}</p>
          </div>
          <div className="form-inputs">
            {this.renderSelect("revenue_sub_account_id", "درآمد", drp.accounts)}
            {this.renderInput("budget", "بودجه", "number")}
            {this.renderSelect("half_year_id", "نیم سال", drp.halfYears)}
            {this.renderFile("attachment", "سند")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default RevenueBudgetForm;
